$(function() {

  if ($('#sysItemDetail').length >= 1) {

    const bread = document.head.children;
    let metalength = bread.length;

    for (let i = 0; i < metalength; i++) {
      let proper = bread[i].getAttribute('type');
      if (proper === 'application/ld+json') {
        console.log(bread[i]);
        let html = bread[i].innerText;
        html = $.trim(html);
        let obj = changeObjct(html);
        console.log('obj:', obj);
        let text = $('.c-breadcrumb__item');
        for (let i = 0; i < obj.itemListElement.length; i++) {
          if (text.eq(i).find('a').length) {
            text.eq(i).find('a').text(obj.itemListElement[i].item.name);
            text.eq(i).find('a').attr('href', obj.itemListElement[i]['item']['@id']);
          } else {
            text.eq(i).text(obj.itemListElement[i].item.name);
          }
        }
      }
    }
  }

  // アイシップアール動的ページのパンくずリストにページ名を入れる
  var ttl = $('#sysMemberRegisterIndex #sysMain h2').text();

  if ($('body').attr('id') === 'sysMypageLogin') {
    ttl = $('.sysMypageMinorHeadLine').text();
    ttl += '・';
    ttl += $('.sysMypageMajorHeadLine').text();
  } else if ($('body').attr('id') === 'sysMypageIndex') {
    ttl = $('.sysMypageMajorHeadLine').text();
  } else if ($('body').attr('id') === 'sysBasket') {
    ttl = $('#sysBasket .sysCartTitle').text();
  } else if ($('body').attr('id') === 'sysMypageLogout') {
    ttl = $('#sysMypageLogout .sysMypageMinorHeadLine').text();
  } else if ($('body').attr('id') === 'sysMypageWithdrawalDone') {
    ttl = '退会完了';
  } else if ($('body').attr('id') === 'sysRegi') {
    ttl = 'ショッピングカート';
  } else if ($('body').attr('id') === 'sysFormIndex' && $('body').attr('class') === 'form-form-cancel') {
    ttl = "返品・交換・返金のお問い合わせ";
  } else if ($('body').attr('id') === 'sysFormConfirm' && $('body').attr('class') === 'form-form-cancel') {
    ttl = "返品・交換・返金のお問い合わせ　確認";
  } else if ($('body').attr('id') === 'sysFormThanks' && $('body').attr('class') === 'form-form-cancel') {
    ttl = "返品・交換・返金のお問い合わせ　完了";
  } else if ($('body').attr('id') === 'sysFormIndex') {
    ttl = 'お問い合わせ';
  } else if ($('body').attr('id') === 'sysFormConfirm') {
    ttl = 'お問い合わせ内容確認';
  } else if ($('body').attr('id') === 'sysFormThanks') {
    ttl = 'お問い合わせ送信完了';
  } else if ($('body').attr('id') === 'sysMypageReminder') {
    var html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">ログイン・マイページ</a></li>';
    html += '<li>会員IDとパスワードの確認</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageEditMember' || $('body').attr('id') === 'sysMypageEditConfirm') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">マイページ</a></li>';
    html += '<li>会員情報編集</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageEditDelivery' || $('body').attr('id') === 'sysMypageEditDeliveryinput') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">マイページ</a></li>';
    html += '<li>お届け先情報を編集する</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageAshiato') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">マイページ</a></li>';
    html += '<li>商品チェック履歴</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageReview') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">マイページ</a></li>';
    html += '<li>お気に入り</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageEditSavedelivery') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">マイページ</a></li>';
    html += '<li>新規にお届け先情報を登録する</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageWithdrawalConfirm') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">マイページ</a></li>';
    html += '<li>会員を退会する</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysBillingAddress') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/cart/basket.html" class="txt-link--red">ショッピングカート</a></li>';
    html += '<li>ご注文者情報の入力</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysDestination') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/cart/basket.html" class="txt-link--red">ショッピングカート</a></li>';
    html += '<li>お届け先情報を選択する</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysPayment' && $('.sysSelectDeliveryArea').length >= 1) {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/cart/basket.html" class="txt-link--red">ショッピングカート</a></li>';
    html += '<li>お届け方法の指定</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysPayment' && $('.sysRemarksArea').length >= 1) {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/cart/basket.html" class="txt-link--red">ショッピングカート</a></li>';
    html += '<li>備考</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysPayment') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/cart/basket.html" class="txt-link--red">ショッピングカート</a></li>';
    html += '<li>お支払方法の選択</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysConfirm') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/cart/basket.html" class="txt-link--red">ショッピングカート</a></li>';
    html += '<li>ご注文内容確認</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysThanks') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/cart/basket.html" class="txt-link--red">ショッピングカート</a></li>';
    html += '<li>ご注文完了</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageEditSave') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">マイページ</a></li><li><a href="https://ssl.aispr.jp/qtis2020/mypage/edit-member.htmll" class="txt-link--red">会員情報編集</a></li>';
    html += '<li>会員情報編集 完了</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMypageRemindermessage') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/mypage/" class="txt-link--red">ログイン・マイページ</a></li>';
    html += '<li>会員IDとパスワードの確認</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMemberRegisterConfirm') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/member/" class="txt-link--red">会員登録</a></li>';
    html += '<li>会員登録 確認</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  } else if ($('body').attr('id') === 'sysMemberRegisterRegister') {
    html = '<li><a href="https://ssl.aispr.jp/qtis2020/member/" class="txt-link--red">会員登録</a></li>';
    html += '<li>会員登録 完了</li>';
    $('.js-bread-crumb-sys').remove();
    $('.bread-crumb ul').append(html);
  }
  $('.js-bread-crumb-sys').text(ttl);
});

function changeObjct(json) {
  const obj = JSON.parse(json);
  return obj;
}
